import React, { useEffect } from 'react'
import { useRaportForm } from '../../context/RaportFormContext'
import Options from './stages/Options'
import CheckboxWithLabelField from '@/modules/drivers/forms/contract/inputs/CheckboxWithLabelField'
import StageHeader from '@/modules/drivers/forms/shared/StageHeader'
import { faSlidersSolid } from '@/lib/fa'
import { DividerHorizontal } from '@/modules/drivers/shared/DividerHorizontal'
import { FieldsetSelect } from '@/modules/settings/components/FieldsetSelect'
import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'

const GROUPED_VIOLATIONS_CHARGES = [
  {
    label: 'printout.company-charge',
    value: '0',
  },
  {
    label: 'printout.driver-charge',
    value: '1',
  },
]

const ViolationsGrouped = () => {
  const { data, setData } = useRaportForm()
  const { t } = useLocalize()

  useEffect(() => {
    setData((prev: any) => ({
      showDetails: false,
      driverCharge: false,
      separateFiles: false,
      issuerSignature: false,
      driverSignature: false,
      ...prev,
    }))
  }, [])

  const driverChargeOptions = Object.values(GROUPED_VIOLATIONS_CHARGES).map(
    (ct) => ({
      value: ct.value.toString(),
      label: t(ct.label),
    }),
  )

  return (
    <div className="tw-flex-1 tw-space-y-4 tw-overflow-auto tw-p-4 tw-pr-8">
      <div className="tw-flex tw-items-start">
        <StageHeader title={t('printout.data')} textSize="sm" icon={faSlidersSolid} />
        <div className="tw-flex tw-flex-1 tw-flex-col tw-gap-1 sm:tw-min-w-[400px]">
          <CheckboxWithLabelField
            field="showDetails"
            data={data}
            setData={setData}
            label={t('printout.show-detailed-amounts-by-violation-type')}
          />

          <FieldsetSelect
            label={t('printout.sort-by')}
            placeholder={t('common.select')}
            searchEnabled={false}
            value={data?.driverCharge === true ? '1' : '0'}
            name="driverCharge"
            onChange={(e) => {
              setData({
                ...data,
                driverCharge: e.target.value === '1',
              })
            }}
            options={driverChargeOptions}
          />
        </div>
      </div>
      <DividerHorizontal />
      <Options
        setData={setData}
        data={data}
        vehicleActivity={false}
        separateFilesOnly={false}
      />
    </div>
  )
}

export default ViolationsGrouped
